<template>
  <v-row no-gutters class="fullscreen">
    <v-col cols="12">
      <v-card elevation="0" min-height="300px">
        <v-form v-model="valid" ref="assignForm">
          <v-card-title>
            Car Gate &nbsp;
            <v-chip color="primary">{{itemId}}</v-chip>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Car Gate Charges"
                  v-model.number="carGate.amount"
                  prepend-icon="local_shipping"
                />
                <v-text-field
                  label="Receive from OS"
                  v-model.number="carGate.receive"
                  prepend-icon="attach_money"
                />
                <v-textarea
                  label="Gate Remark"
                  v-model.trim="carGate.gateRemark"
                  rows="3"
                  prepend-icon="description"
                ></v-textarea>
              </v-col>

              <v-col offset-md="4" cols="12" md="4">
                <v-alert border="left" colored-border color="black" elevation="1">
                  <ul>
                    <li>Date : {{carGate.date | formatDateTime($moment)}}</li>
                    <li>ModifiedDate : {{carGate.modifiedDate | formatDateTime($moment)}}</li>
                  </ul>
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" v-if="carGate.gateId == 0" @click="beforeSaveGate">
              <v-icon>save</v-icon>Save
            </v-btn>
            <v-btn color="primary" v-else @click="beforeUpdateGate">
              <v-icon>edit</v-icon>Update
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn depressed fab small color="primary" outlined>
              <v-icon>help</v-icon>
            </v-btn>
            <v-btn text>Cancel</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  mounted: function () {},
  data() {
    return {
      valid: false,
    };
  },
  props: {
    carGate: {
      gateId: Number,
      transactionId: Number,
      amount: Number,
      receive: Number,
      balance: Number,
      gateRemark: String,
      date: String,
      modifiedDate: String,
    },
    itemId: Number,
    status: String,
    saveGate: Function,
    updateGate: Function,
    loadGate: Function,
  },
  methods: {
    beforeSaveGate: function () {
      this.saveGate(this.carGate);
    },
    beforeUpdateGate: function () {
      this.updateGate(this.carGate);
    },
    reloadCargate: function () {
      if (this.itemId != 0 && this.status != "NONE") {
        this.loadGate();
      }
    },
  },
  watch: {
    itemId: function () {
      this.reloadCargate();
    },
    status: function () {
      this.reloadCargate();
    },
  },
};
</script>

<style scoped>
.fullscreen {
  height: 81vh;
}
</style>